require('slick-carousel');

document.addEventListener('DOMContentLoaded', () => {
	function initSlider({ carousel, prevBtn, nextBtn }) {
		if (!carousel || $(carousel).hasClass('slick-initialized')) return; // already inited or missing

		$(carousel).slick({
			infinite: true,
			speed: 350,
			slidesToScroll: 1,
			arrows: true,
			variableWidth: true,
			prevArrow: $(prevBtn || '<button type="button" class="slick-prev"></button>'),
			nextArrow: $(nextBtn || '<button type="button" class="slick-next"></button>'),
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						variableWidth: false,
					},
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
						variableWidth: false,
					},
				},
			],
		});
	}

	const featureWrappers = document.querySelectorAll('.content-section__lh-explore');

	if (!featureWrappers.length) {
		console.warn('No feature wrappers found for slider initialization');
	} else {
		featureWrappers.forEach((wrapper) => {
			const carousel = wrapper.querySelector('.hub-items');
			const prevBtn = wrapper.querySelector('.hub-items-button-prev');
			const nextBtn = wrapper.querySelector('.hub-items-button-next');

			initSlider({ carousel, prevBtn, nextBtn });
		});
	}

	// Learning hub landing
	function tutorialVideoGallery() {
		const modal = document.getElementById('global-video-modal');
		if (!modal) return; // already inited or missing
		const iframe = modal.querySelector('.sb-video-iframe');
		const titleEl = modal.querySelector('.modal__header-title');

		const videoButtons = document.querySelectorAll('[data-video-src]');

		videoButtons.forEach(btn => {
			btn.addEventListener('click', () => {
				const src = btn.dataset.videoSrc;
				const title = btn.dataset.videoTitle || '';

				titleEl.textContent = title;
				iframe.setAttribute('data-src', src);
				setTimeout(function (){
					iframe.src = src;
				})

				$(modal).modal('show'); // Bootstrap
			});
		});
	}
	tutorialVideoGallery();

	const scrollTabsContainer = document.querySelector('.scroll-tabs');

	function scrollActiveAnchorIntoView(force = false) {
		//console.log('scrollActiveAnchorIntoView');
		if (!scrollTabsContainer) return;

		const activeLink = scrollTabsContainer.querySelector('.sticky-anchors__link.active');
		if (!activeLink) return;

		// Skip if container doesn't scroll horizontally
		if (!force && scrollTabsContainer.scrollWidth <= scrollTabsContainer.clientWidth) {
			return;
		}

		const containerRect = scrollTabsContainer.getBoundingClientRect();
		const activeRect = activeLink.getBoundingClientRect();

		const offsetLeft = activeRect.left - containerRect.left;

		// HERE: Always scroll so the active item sticks to the LEFT
		const targetScrollLeft = scrollTabsContainer.scrollLeft + offsetLeft - 16;
		// 16px for nice small padding – optional

		scrollTabsContainer.scrollTo({
			left: targetScrollLeft,
			behavior: 'smooth',
		});
	}


	requestAnimationFrame(() => scrollActiveAnchorIntoView(true));
	window.addEventListener('load', () => scrollActiveAnchorIntoView(true));


	document.addEventListener('click', (e) => {
		const link = e.target.closest('.sticky-anchors__link');
		if (!link) return;

		requestAnimationFrame(() => scrollActiveAnchorIntoView(true));
		setTimeout(() => scrollActiveAnchorIntoView(true), 50);
		setTimeout(() => scrollActiveAnchorIntoView(true), 150);
	});

	const navList = document.querySelector('#nav-list');

	if (navList) {
		const observer = new MutationObserver(() => {
			requestAnimationFrame(() => scrollActiveAnchorIntoView(true));
		});

		observer.observe(navList, {
			attributes: true,
			subtree: true,
			attributeFilter: ['class'],
		});
	}
});
